import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { HasProduct, withProduct } from "@insite/client-framework/Components/ProductContext";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import NISProductAlertMessage from "@tCentro/Components/NISProductAlertMessage";
import NISProductSpecialMessage from "@tCentro/Components/NISProductSpecialMessage";
import * as React from "react";
import { css } from "styled-components";

type Props = WidgetProps & HasProduct;

export interface NISProductMessagesStyles {
    wrapper?: InjectableCss;
}

export const nisProductMessagesStyles: NISProductMessagesStyles = {
    wrapper: {
        css: css`
            margin-top: 8px;
            margin-bottom: 8px;
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null,
                        null,
                        css`
                            margin-bottom: 12px;
                        `,
                        null,
                        null,
                    ],
                    "max",
                )}
        `,
    },
};

const styles = nisProductMessagesStyles;

const NISProductMessages: React.FC<Props> = ({ product }) => {
    if (!product.properties) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            {product.properties.specialMessage && (
                <NISProductSpecialMessage specialMessage={product.properties.specialMessage} />
            )}
            {product.properties.alertMessage && (
                <NISProductAlertMessage alertMessage={product.properties.alertMessage} />
            )}
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: withProduct(NISProductMessages),
    definition: {
        displayName: "NIS Product Messages",
        group: "Product Details",
        allowedContexts: ["ProductDetailsPage"],
    },
};

export default widgetModule;
